//const {dialog} = window.require('electron').remote
const dialog = {}

function filterImages(vm) {
  return [
    { name: vm.$t('media_type_photo'), extensions: ['jpg', 'jpeg', 'png', 'gif'] }
  ]
}

function filterVideos(vm) {
  return [
    { name: vm.$t('media_type_video'), extensions: ['mp4'] }
  ]
}

function openImages(vm, multipleFiles) {
  return dialog.showOpenDialog({ 
    filters: filterImages(vm),
    properties: [ 
      'openFile' , multipleFiles ? 'multiSelections' : ''
    ]
  })
}

const fileSelector = {
  getImagesFilter: filterImages,
  getVideosFilter: filterVideos,

  /**
   * Show select images dialog
   */
  openImages: (vm) => {
    return openImages(vm, true)
  },
  openAvatarImage: (vm) => {
    let filename = dialog.showOpenDialog({ 
      filters: [
        { name: vm.$t('media_type_photo'), extensions: ['jpg', 'png', 'jpeg'] }
      ],
      properties: [ 
        'openFile'
      ]
    })
    // small fix for windows
    return (filename !== undefined) ? filename.toString().replace(/\\/g, "/") : ''
  },
  openVideos: (vm) => {
    return dialog.showOpenDialog({ 
      filters: filterVideos(vm),
      properties: [ 
        'openFile', 'multiSelections'
      ]
    })
  },
  openDocuments: () => {
    return dialog.showOpenDialog({ 
      properties: [ 
        'openFile', 'multiSelections'
      ]
    })
  },
  openBackground: (vm) => {
    return openImages(vm, false)
  },
}

export default fileSelector